/**
 * Switching profile or mode is a state change, not a navigation, so react-router's blocker never
 * sees it. A page with unsaved changes registers a guard here; the switchers run their change
 * through `whenSafeToLeave`, which asks first while a guard is registered.
 */
type Guard = (proceed: () => void) => void;

let guard: Guard | null = null;

/** Registers the page's guard; returns the function that removes it again. */
export function registerLeaveGuard(g: Guard): () => void {
  guard = g;
  return () => {
    if (guard === g) guard = null;
  };
}

/** Runs `proceed` now, or once the user agrees to discard the unsaved changes. */
export function whenSafeToLeave(proceed: () => void) {
  if (guard) guard(proceed);
  else proceed();
}
